(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["commerce-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class CommerceHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      this.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.select(this.index - 1));
      this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.select(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.select(Number(dot.dataset.sliderDot))));

      if (
        this.dataset.autoplay === 'true' &&
        this.slides.length > 1 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    select(nextIndex) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, index) => {
        const isActive = index === this.index;
        slide.classList.toggle('is-active', isActive);
        slide.toggleAttribute('aria-hidden', !isActive);
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === this.index;
        dot.classList.toggle('is-active', isActive);
        dot.toggleAttribute('aria-current', isActive);
      });
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.select(this.index + 1), Number(this.dataset.autoplaySpeed) || 5000);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  if (!customElements.get('commerce-hero-slider')) {
    customElements.define('commerce-hero-slider', CommerceHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
